var _linearGradient, _linearGradient2, _path, _linearGradient3, _path2, _linearGradient4, _path3, _linearGradient5, _path4, _linearGradient6, _path5, _linearGradient7, _path6, _linearGradient8, _path7, _linearGradient9, _path8, _linearGradient10, _path9, _linearGradient11, _path10, _path11, _linearGradient12, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternalDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_0f11f08ac7c60075455f41fc8f3e191776fcdcac0470a185df49237a631da398",
    gradientUnits: "userSpaceOnUse",
    x1: -499.146,
    y1: -961.914,
    x2: -498.146,
    y2: -961.914
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_0f11f08ac7c60075455f41fc8f3e191776fcdcac0470a185df49237a631da398",
    gradientUnits: "userSpaceOnUse",
    x1: 105.484,
    y1: 69.109,
    x2: 120.843,
    y2: 69.109
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_0f11f08ac7c60075455f41fc8f3e191776fcdcac0470a185df49237a631da398)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M106.734 69.109h12.859"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_0f11f08ac7c60075455f41fc8f3e191776fcdcac0470a185df49237a631da398",
    gradientUnits: "userSpaceOnUse",
    x1: 105.484,
    y1: 77.821,
    x2: 120.843,
    y2: 77.821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_2_0f11f08ac7c60075455f41fc8f3e191776fcdcac0470a185df49237a631da398)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M106.734 77.821h12.859"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_0f11f08ac7c60075455f41fc8f3e191776fcdcac0470a185df49237a631da398",
    gradientUnits: "userSpaceOnUse",
    x1: 105.484,
    y1: 85.96,
    x2: 120.843,
    y2: 85.96
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_3_0f11f08ac7c60075455f41fc8f3e191776fcdcac0470a185df49237a631da398)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M106.734 85.96h12.859"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_0f11f08ac7c60075455f41fc8f3e191776fcdcac0470a185df49237a631da398",
    gradientUnits: "userSpaceOnUse",
    x1: 76.39,
    y1: 69.109,
    x2: 91.748,
    y2: 69.109
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_4_0f11f08ac7c60075455f41fc8f3e191776fcdcac0470a185df49237a631da398)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M77.64 69.109h12.858"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_0f11f08ac7c60075455f41fc8f3e191776fcdcac0470a185df49237a631da398",
    gradientUnits: "userSpaceOnUse",
    x1: 76.39,
    y1: 77.821,
    x2: 91.748,
    y2: 77.821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_5_0f11f08ac7c60075455f41fc8f3e191776fcdcac0470a185df49237a631da398)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M77.64 77.821h12.858"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_0f11f08ac7c60075455f41fc8f3e191776fcdcac0470a185df49237a631da398",
    gradientUnits: "userSpaceOnUse",
    x1: 76.39,
    y1: 85.96,
    x2: 91.748,
    y2: 85.96
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_0f11f08ac7c60075455f41fc8f3e191776fcdcac0470a185df49237a631da398)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M77.64 85.96h12.858"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_0f11f08ac7c60075455f41fc8f3e191776fcdcac0470a185df49237a631da398",
    gradientUnits: "userSpaceOnUse",
    x1: 105.484,
    y1: 94.434,
    x2: 120.843,
    y2: 94.434
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_7_0f11f08ac7c60075455f41fc8f3e191776fcdcac0470a185df49237a631da398)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M106.734 94.434h12.859"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_0f11f08ac7c60075455f41fc8f3e191776fcdcac0470a185df49237a631da398",
    gradientUnits: "userSpaceOnUse",
    x1: 105.484,
    y1: 102.572,
    x2: 120.843,
    y2: 102.572
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_8_0f11f08ac7c60075455f41fc8f3e191776fcdcac0470a185df49237a631da398)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M106.734 102.572h12.859"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_0f11f08ac7c60075455f41fc8f3e191776fcdcac0470a185df49237a631da398",
    gradientUnits: "userSpaceOnUse",
    x1: 76.39,
    y1: 94.434,
    x2: 91.748,
    y2: 94.434
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_9_0f11f08ac7c60075455f41fc8f3e191776fcdcac0470a185df49237a631da398)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M77.64 94.434h12.858"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_0f11f08ac7c60075455f41fc8f3e191776fcdcac0470a185df49237a631da398",
    gradientUnits: "userSpaceOnUse",
    x1: 76.39,
    y1: 102.572,
    x2: 91.748,
    y2: 102.572
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_10_0f11f08ac7c60075455f41fc8f3e191776fcdcac0470a185df49237a631da398)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M77.64 102.572h12.858"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M99.26 59.627v51.496"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_0f11f08ac7c60075455f41fc8f3e191776fcdcac0470a185df49237a631da398",
    gradientUnits: "userSpaceOnUse",
    x1: 72.547,
    y1: 52.458,
    x2: 125.974,
    y2: 52.458
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_11_0f11f08ac7c60075455f41fc8f3e191776fcdcac0470a185df49237a631da398)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M73.797 46.01h50.927v12.897H73.797z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M59.72 46.219H42.026V29.548c0-4.701 3.984-8.549 8.842-8.549 4.868 0 8.852 3.848 8.852 8.549v16.671z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M50.873 20.884h79.716c4.868 0 8.852 3.85 8.852 8.545V137.545H59.684l.036-91.325"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalDocuments);
export default __webpack_public_path__ + "static/media/internalDocuments.eb697b214f7a58abde0a841a35326929.svg";
export { ForwardRef as ReactComponent };